import { render, staticRenderFns } from "./diagnostic.vue?vue&type=template&id=185596aa&"
import script from "./diagnostic.vue?vue&type=script&lang=js&"
export * from "./diagnostic.vue?vue&type=script&lang=js&"
import style0 from "./diagnostic.vue?vue&type=style&index=0&id=185596aa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./diagnostic.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports